import {Inject, Injectable, DOCUMENT} from '@angular/core';
import {DefaultPortalConfig, PortalConfig} from '@shared/portal-config';


@Injectable({
  providedIn: 'root'
})
export class ThemingService {
  constructor(@Inject(DOCUMENT) private readonly document: Document,
              private readonly config: PortalConfig) {
  }

  public apply() {
    this.applyThemeColour();
    this.applyCustomFontFamily();
    this.applyCustomFontColour();
  }

  private applyThemeColour() {
    if (!this.config.themeColour || this.config.themeColour === DefaultPortalConfig.themeColour) {
      return;
    }

    // Angular normally uses directives to modify the DOM; however, we need a CSS variable applied above the root of any Angular component, which a directive cannot achieve
    // If this is run outside the browser, any element might be undefined, so try set the --theme-colour CSS variable on the <body> element of the current document safely
    this.document.body?.style?.setProperty?.('--theme-colour', this.config.themeColour);
  }

  private applyCustomFontFamily() {
    if (!this.config.fontFamily) {
      return;
    }

    this.document.body?.style?.setProperty?.('--font-family', this.config.fontFamily);
  }

  private applyCustomFontColour() {
    if (!this.config.fontColour) {
      return;
    }

    this.document.body?.style?.setProperty?.('--font-colour', this.config.fontColour);
  }
}
